import { NgModule } from '@angular/core';
import { TooltipModule } from './../tooltip/tooltip.module';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';
import { GroupedBarChartComponent } from './grouped-bar-chart/grouped-bar-chart.component';
import { HorizontalBarChartComponent } from './horizontal-bar-chart/horizontal-bar-chart.component';
import { HorizontalGroupedBarChartComponent } from './horziontal-grouped-bar-chart/horizontal-grouped-bar-chart.component';

@NgModule({
  imports: [
    TooltipModule
  ],
  declarations: [
    DoughnutChartComponent,
    GroupedBarChartComponent,
    HorizontalBarChartComponent,
    HorizontalGroupedBarChartComponent
  ],
  exports: [
    DoughnutChartComponent,
    GroupedBarChartComponent,
    HorizontalBarChartComponent,
    HorizontalGroupedBarChartComponent
  ]
})
export class ChartModule { }
